module.exports = __webpack_public_path__ + "img/ez-slot-category-sport-mobile.4a6df5d9.png";